<template>
  <div
    class="page"
  >
    <Header
      :setting="{
        title: '醫療團隊',
        hasCancelMethod: true,
      }"
      @cancel="$emit('cancel')"
      class="mb4"
    />
    <div class="row--central mb4">
      <div class="label label--secondary  ph4">
        {{ currentDivision }}
      </div>
    </div>
    <div class="row--end mb4">
      <div
        v-if="divisionsHaveSchedule.includes(currentDivision)"
        @click="$router.push({
          path: `/appointment/schedule/${currentDivision}`})"
        class="label label--primary row--central"
      >
        <font-awesome-icon :icon="['fas', 'calendar-alt']" />
        <div class="ml2">
          前往門診表
        </div>
      </div>
    </div>
    <div
      v-for="doctor in doctors"
      :key="doctor"
      class="bc--secondary border-radius-3 column--start mb6"
    >
      <div class="row--central mv4">
        <img
          :src="doctor.doctorPhotoUrl"
          alt=""
          class="image--size-x-7 image--circle"
        >
      </div>
      <div class="fs4 fw3 mb3">
        {{ doctor.name }} {{ doctor.jobTitle }}
      </div>
      <div class="fc--primary mb3">
        {{ doctor.currentPosition }}
      </div>
      <div class="page__text align--left mv4 mh6">
        {{ doctor.experience }}
      </div>
    </div>
    <div v-if="doctors.length===0">
      尚未有醫師在本科新增。
    </div>
  </div>
</template>

<script>
export default {
  props: {
    doctors: {
      type: Array,
      default() {
        return [];
      },
    },
    currentDivision: {
      type: String,
      default: '',
    },
    divisionsHaveSchedule: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  emits: ['cancel'],
};
</script>
